import React from "react";
// import ContactForm from "../components/ContactForm";
import SectionHeading from "../components/SectionHeading";

/**
 * Contact page
 * Props:
 *  - content: siteContent.contact
 */
function Contact({ content }) {
  return (
    <>
      <section className="hero-section py-5">
        <div className="container text-center">
          <h1 className="fw-bold display-6 mb-2">{content.title}</h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>{content.subtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-5">
              <SectionHeading eyebrow="Reach out" title="Contact Information" align="start" />
              <ul className="list-unstyled">
                <li className="d-flex align-items-start gap-3 mb-4">
                  <div className="icon-circle flex-shrink-0"><i class="bi bi-person-fill"></i></div>
                  <div>
                    <div className="fw-bold text-navy">Name</div>
                    <div className="text-secondary">{content.name} - {content.role}</div>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-3 mb-4">
                  <div className="icon-circle flex-shrink-0"><i className="bi bi-geo-alt-fill"></i></div>
                  <div>
                    <div className="fw-bold text-navy">Location</div>
                    <div className="text-secondary">{content.address}</div>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-3 mb-4">
                  <div className="icon-circle flex-shrink-0"><i className="bi bi-envelope-fill"></i></div>
                  <div>
                    <div className="fw-bold text-navy">Email</div>
                    <div className="text-secondary"><a href={`mailto:${content.email}`}>{content.email}</a></div>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-3 mb-4">
                  <div className="icon-circle flex-shrink-0"><i className="bi bi-telephone-fill"></i></div>
                  <div>
                    <div className="fw-bold text-navy">Phone</div>
                    <div className="text-secondary"><a href={`tel:${content.phone}`}>{content.phone}</a></div>
                  </div>
                </li>
              </ul>
            </div>

            {/* <div className="col-lg-7">
              <div className="card apk-card p-4 p-md-5">
                <h4 className="fw-bold text-navy mb-4">Send us a message</h4>
                <ContactForm />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
